import { render, staticRenderFns } from "./bgyl.vue?vue&type=template&id=4ae9d370&scoped=true&"
import script from "./bgyl.vue?vue&type=script&lang=js&"
export * from "./bgyl.vue?vue&type=script&lang=js&"
import style0 from "./bgyl.vue?vue&type=style&index=0&id=4ae9d370&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae9d370",
  null
  
)

export default component.exports